import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Footer from '../components/Footer'
import Container from '../components/Container';
import Header from '../components/Header';
import HomeBanner from '../components/HomeBanner';
import './index.scss'

// const Header = () => (
//   <div
//     style={{
//       background: '#a3d2d7',
//       marginBottom: '1.45rem',
//       position: 'absolute',
//       bottom: 0,
//       width: '100%'
//     }}
//   >
//     <div
//       style={{
//         margin: '0 auto',
//         maxWidth: 960,
//         padding: '1.45rem 1.0875rem',
//       }}
//     >
//       <h1 style={{ margin: 0 }}>
//         <Link
//           to="/"
//           style={{
//             color: '#a3d2d7',
//             textDecoration: 'none',
//           }}
//         >
//           Gatsby
//         </Link>
//       </h1>
//     </div>
//   </div>
// )

class TemplateWrapper extends Component {
  constructor(props) {
    super(props);

    this.getHeader = this.getHeader.bind(this);
  }

  getHeader() {
    const { pathname } = this.props.location;

    if (pathname === '/') return <HomeBanner />
    return <Header pathname={pathname} />
  }

  render() {
    return (
      <div>
        <Helmet
          title="CustomCard"
          meta={[
            { name: 'description', content: 'CustomCard' },
            { name: 'keywords', content: 'sample, something' },
          ]}
          htmlAttributes={{"lang": "en"}}
        />
        <Container>
          {this.getHeader()}
          {this.props.children()}
        </Container>
        <Footer />
      </div>
    );
  }
}

//
// const TemplateWrapper = ({ children }) => (
//   <div>
//     <Helmet
//       title="Gatsby Default Starter"
//       meta={[
//         { name: 'description', content: 'Sample' },
//         { name: 'keywords', content: 'sample, something' },
//       ]}
//     />
//     {
//       this.props.location.pathname != '/' ? '' : <Header />
//     }
//     <div
//       style={{
//         margin: '0 auto',
//         maxWidth: 960,
//         padding: '0px 1.0875rem 1.45rem',
//         paddingTop: 0,
//       }}
//     >
//       {children()}
//     </div>
//     <Footer />
//   </div>
// )

TemplateWrapper.propTypes = {
  children: PropTypes.func,
  location: PropTypes.object,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js